import React from 'react';

export default function VerifierForm({
  mode,
  setMode,
  targetHandle,
  onChangeHandle,
  selectedListUri,
  setSelectedListUri,
  userLists,
  isLoadingLists,
  isVerifying,
  isDuplicateHandle,
  duplicateDate,
  onSubmit,
}) {
  return (
    <div className="verifier-section">
      <h2>Verify an ATmosphere account</h2>
      <form onSubmit={onSubmit} className="verifier-form-container">
        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          disabled={isVerifying}
        >
          <option value="account">Account</option>
          <option value="list">User List</option>
        </select>

        {mode === 'account' ? (
          <input
            type="text"
            value={targetHandle}
            onChange={onChangeHandle}
            placeholder="username.bsky.social"
            disabled={isVerifying}
            required
            autoComplete="off"
          />
        ) : (
          <select
            value={selectedListUri}
            onChange={(e) => setSelectedListUri(e.target.value)}
            disabled={isVerifying || isLoadingLists}
            required
          >
            <option value="">
              {isLoadingLists ? 'Loading your lists...' : 'Select a list to verify'}
            </option>
            {userLists.map(list => (
              <option key={list.uri} value={list.uri}>
                {list.name} ({list.listItemCount ?? 0} members)
              </option>
            ))}
          </select>
        )}

        <button
          type="submit"
          disabled={isVerifying || (mode === 'account' ? !targetHandle : !selectedListUri)}
          className="verifier-submit-button"
        >
          {isVerifying ? 'Verifying...' : 'Verify Account'}
        </button>
      </form>

      {/* P5: trust caveat near the primary action */}
      <p className="verifier-trust-caveat">
        This writes a verification record to YOUR repo. Whether a badge appears in Bluesky or other apps
        depends on whether that app trusts you as a verifier. Records are public.
      </p>

      {mode === 'account' && isDuplicateHandle && (
        <p className="verifier-duplicate-note">
          Already verified on {duplicateDate} — see your verifications below.
        </p>
      )}

      {mode === 'list' && !isLoadingLists && userLists.length === 0 && (
        <p className="verifier-duplicate-note">
          You don't have any user lists. Create one on Bluesky first.
        </p>
      )}
    </div>
  );
}
